<template>
  <base-layout>
    <div class="col-xs-12 main" slot="main">
      <div class="row ls-charts appointments">
        <h1><router-link to="/campaigns">Campaigns</router-link> &gt; {{ campaign_name }}</h1>
        <!-- step 1 -->
        <div class="row">
          <div class="col-xs-12 doc-wrapper">
            <div class="box panel">
              <div class="panel-body">
                <h2>1. Find Appointments</h2>
                <transition name="slide">
                  <div class="col-xs-12 col-lg-10 col-lg-offset-1" v-show="!step3">
                    <div class="row">
                      <FormulateForm class="col-xs-12 col-md-2 slots-ui">
                        <div class="col-xs-12">
                          <FormulateInput
                            v-model="zipcode"
                            name="zipcode"
                            type="text"
                            label="Zip Code *"
                            :error="findSlotsErrors.zipcode" />
                          <FormulateInput
                            v-model="desired_date"
                            name="appointment_date"
                            type="date"
                            label="Appointment date"
                            :error="findSlotsErrors.desired_date" />
                          <!-- <FormulateInput
                               v-if="carrierPreferenceValues.length > 1"
                               v-model="carrier_preference"
                               name="carrier_preference"
                               type="select"
                               label="Carrier Preference"
                               :options="carrierPreferenceOptions"
                               :error="findSlotsErrors.carrier_preference" /> -->
                          <div class="col-xs-12 text-right buttons-wrapper">
                            <button :disabled="loadingSlots" class="btn btn-primary" @click="findSlots">Find Slots</button>
                            <div class="waiting-spinner" v-if="loadingSlots"><i class="fa fa-spinner fa-spin"></i> <small>loading...</small></div>
                            <div v-show="findSlotsErrors.non_field_errors" class="text-danger">{{ findSlotsErrors.non_field_errors }}</div>
                          </div>
                        </div>
                      </FormulateForm>
                      <transition name="slide">
                        <div v-if="step2 && !loadingSlots" class="col-xs-12 col-md-10 slots-ui">
                          <table v-if="availableSlots.length" class="table table-condensed">
                            <thead>
                              <tr>
                                <th>Time</th>
                                <th v-for="header in tableHeader">{{ header }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="slots in slotsByTime">
                                <th>{{ slots[0] }}</th>
                                <td v-for="slot in slots.slice(1)">
                                  <div v-if="slot" class="col-xs-12 appointment-slot" :class="{selected: slot.selected}">
                                    <div class="appointment-options col-xs-12">
                                      <button v-for="slots_per_type in slot.appointment_types"
                                        class="btn" :class="appointmentTypeButton[slots_per_type.appointment_type]"
                                        :title="appointmentTypeOptions[slots_per_type.appointment_type] + (slots_per_type.location ? ' @ ' + slots_per_type.location : '')"
                                        :disabled="slot.selected && slot.appointment_type == slots_per_type.appointment_type && slot.location == slots_per_type.location"
                                              @click="selectSlot(slot, slots_per_type)" >
                                        <i class="fa fa-lg" :class="appointmentTypeIcons[slots_per_type.appointment_type]"></i>
                                        <small v-if="slots_per_type.location"> {{ slots_per_type.location }}</small>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-else class="no-slots">
                            <p class="lead">No slots available</p>
                            <p>
                              No licensed agents available in this zip code.
                            </p>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <div class="row">
                      <div  v-if="availableSlots.length" class="col-md-offset-2 col-md-10 col-xs-12 text-right slots-ui buttons-wrapper">
                        <button class="btn btn-primary" :disabled="!selectedSlot || confirmingSelection" @click="bookAppointment">Confirm Selection</button>
                        <div class="waiting-spinner" v-if="confirmingSelection"><i class="fa fa-spinner fa-spin"></i> <small>loading...</small></div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <!-- step 3 -->
          <div class="col-xs-12 doc-wrapper">
            <div class="box panel step3">
              <div class="panel-body">
                <h2>2. Appointment Information</h2>
                <transition name="slide">
                  <div v-show="step3" class="panel-body">
                    <div class="col-xs-12">
                      <div v-if="bookedAppointment" class="col-xs-12 col-lg-6 col-lg-offset-3">
                        <h3>Selected Appointment</h3>
                        <div class="well text-danger"><i class="fa fa-warning fg-2x"></i> <strong>Appointments must be sent within {{ bookedAppointment.blocked_period }} minutes or they will expire</strong></div>
                        <table class="table col-xs-12">
                          <tbody>
                            <tr>
                              <th>ID</th>
                              <td>
                                <span class="text-bold">{{ bookedAppointment.id }}</span>
                                <button class="btn btn-info" @click="copyAppointmentId()"><i class="fa fa-copy"></i>&nbsp;Copy</button>
                                <span v-if="copyFeedback" class="copied-feedback"></span>
                              </td>
                            </tr>
                            <tr><th>Company</th><td>{{ bookedAppointment.agent.agency }}</td></tr>
                            <tr><th>Appointment Type</th><td>{{ appointmentTypeOptions[bookedAppointment.appointment_type] }}</td></tr>
                            <tr><th>Appointment Date</th><td>{{ bookedAppointmentStartTime }}</td></tr>
                            <tr><th>Agent Name</th><td>{{ bookedAppointment.agent.name }}</td></tr>
                            <tr><th><i class="fa fa-at"></i> Agent Email</th><td>{{ bookedAppointment.agent.email }}</td></tr>
                            <tr><th><i class="fa fa-phone"></i> Agent Phone</th><td>{{ bookedAppointment.agent.phone }}</td></tr>
                            <tr v-if="bookedAppointment.appointment_type == 'in-person-at-office'">
                              <th><i class="fa fa-map-marker"></i> Office Address</th><td>{{ bookedAppointment.appointment_location }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-xs-12 col-lg-6 col-lg-offset-3 submit text-right buttons-wrapper">
                      <button class="btn btn-warning" :disabled="loadingSlots" @click="cancelAppointment">Cancel & Back</button>
                      <div v-if="loadingSlots"><i class="fa fa-spinner fa-spin"></i> <small>loading...</small></div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <transition name="fade">
              <div v-if="appointmentIdCopied" class="col-xs-12 doc-wrapper text-center">
                <button class="btn btn-primary btn-lg" :disabled="loadingSlots" @click="restart"><i class="fa fa-calendar-plus-o"></i> New Appointment</button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
  import {BaseLayout} from 'components/layouts';

  export default {
    components: {
      BaseLayout,
    },
    data() {
      return {
        campaign_id: null,
        campaign_name: null,
        zipcode: null,
        carrier_preference: null,
        desired_date: null,
        desired_time: null,
        selectedSlot: null,
        availableSlots: [],
        step2: false,
        step3: false,
        loadingSlots: false,
        confirmingSelection: false,
        appointmentTypes: [],
        bookedAppointment: null,
        carrierPreferenceValues:[],
        findSlotsErrors: {
          desired_date: null,
          desired_time: null,
          appointment_type: null,
          zipcode: null,
          carrier_preference: null,
          non_field_errors: null,
        },
        copyFeedback: false,
        timezone: null,
        appointmentIdCopied: false
      };
    },
    computed: {
      tableHeader: function () {
        let res = [];
        let visited = new Set();

        this.availableSlots.forEach((slot) => {
          let day = this.getDayLabel(slot);

          if (!visited.has(day)) {
            res.push(day);
            visited.add(day);
          }
        });

        return res;
      },
      appointmentTypeIcons: function () {
        let res = {};

        this.appointmentTypes.forEach((s) => {
          switch (s.value) {
            case 'phone-call':
              res[s.value] = 'fa-phone';
              break;
            case 'in-person-at-home':
              res[s.value] =  'fa-home';
              break;
            case 'in-person-at-office':
              res[s.value] = 'fa-building-o';
              break;
            case 'online':
              res[s.value] = 'fa-video-camera';
              break;
          }
        });

        return res;
      },
      appointmentTypeButton: function () {
        let res = {};

        this.appointmentTypes.forEach((s) => {
          switch (s.value) {
            case 'phone-call':
              res[s.value] = 'btn-success';
              break;
            case 'in-person-at-home':
              res[s.value] =  'btn-warning';
              break;
            case 'in-person-at-office':
              res[s.value] = 'btn-primary';
              break;
            case 'online':
              res[s.value] = 'btn-info';
              break;
          }
        });

        return res;
      },
      appointmentTypeOptions: function () {
        let res = {};

        this.appointmentTypes.forEach((s) => {
          res[s.value] = s.display_name;
        });

        return res;
      },
      carrierPreferenceOptions: function () {
        let res = {
          '': '-'
        };

        this.carrierPreferenceValues.forEach((c) => {
          res[c.value] = c.display_name;
        });

        return res;
      },
      slotsByTime: function () {
        let times = {};
        let days = this.tableHeader;

        this.availableSlots.forEach((slot) => {
          let timeKey = this.getTimeKey(slot);

          if (times[timeKey] === undefined) {
            times[timeKey] = Array(days.length + 1).fill(null);
            times[timeKey][0] = this.getTimeLabel(slot)
          }

          let dayPos = days.indexOf(this.getDayLabel(slot));
          if (dayPos > -1) {
            times[timeKey][dayPos + 1] = slot;
          }

        });

        let timeIndex = Object.keys(times);
        timeIndex.sort()
        let res = [];

        timeIndex.forEach((ix) => {
          res.push(times[ix])
        })

        return res;
      },
      bookedAppointmentStartTime: function () {
        if (this.bookedAppointment && this.timezone) {
          return (new Date(this.bookedAppointment.start_timestamp)).toLocaleString(
            'en-US',
            {timeZone: this.timezone, timeZoneName: 'short'});
        }
      }
    },
    created () {
      this.fetchCampaign();
    },
    methods: {
      getDayLabel(slot) {
        return (new Date(slot.start_timestamp))
          .toLocaleDateString('en-US',
                              {timeZone: slot.timezone,
                               weekday: 'short',
                               year: 'numeric',
                               month: 'short',
                               day: 'numeric'});
      },
      getTimeLabel(slot) {
        return new Date(slot.start_timestamp).toLocaleTimeString(
          'en-US',
          {timeZone: slot.timezone,
           timeZoneName: 'short',
           hour: '2-digit',
           minute: '2-digit'});
      },
      getTimeKey(slot) {
        return new Date(slot.start_timestamp).toLocaleTimeString(
          'en-US',
          {timeZone: slot.timezone,
           hour12: false,
           hour: '2-digit',
           minute: '2-digit'});
      },
      async fetchCampaign() {
        let id = this.$route.params.id;
        let campaignResponse = await API.providerCampaigns.read(id);

        this.campaign_id = campaignResponse['body'].id;
        this.campaign_name = campaignResponse['body'].name;

        let findSlotOptions = await API.providerCampaigns.getFindSlotOptions(id);
        // Appointment Types are pulled, but not used as of now
        this.appointmentTypes = findSlotOptions['body']['actions']['POST']['appointment_types']['choices'];
        this.carrierPreferenceValues = findSlotOptions['body']['actions']['POST']['carrier_preference']['choices'];
      },
      async findSlots() {
        this.selectedSlot = null;
        this.loadingSlots = true;
        Object.keys(this.findSlotsErrors).forEach((key) => {
          this.findSlotsErrors[key] = null;
        });

        let req = {};
        if (this.zipcode) {
          req['zipcode'] = this.zipcode;
        }
        if (this.desired_date) {
          req['desired_date'] = this.desired_date;

        }
        if (this.desired_time) {
          req['desired_time'] = this.desired_time;
        }

        if (this.carrier_preference) {
          req['carrier_preference'] = [this.carrier_preference];
        }

        try {
          this.availableSlots = [];
          let response = await API.providerCampaigns.findSlots(this.campaign_id, req);
          this.availableSlots = response.body.results;
          this.availableSlots.sort((a, b) => a.start_timestamp < b.start_timestamp ? -1 : 1);
          this.step2 = true;
          this.loadingSlots = false;
        } catch (err) {
          this.handleErrorResponse(this.findSlotsErrors, err);
          this.step2 = false;
          this.loadingSlots = false;
        }
      },
      async bookAppointment() {
        this.confirmingSelection = true;
        let req = {
          zipcode: this.zipcode,
          slot_options: this.selectedSlot.slots,
          carrier_preference: this.selectedSlot.carrier_preference
        }

        try {
          let response = await API.providerCampaigns.bookAppointment(this.campaign_id, req);
          this.bookedAppointment = response.body;
          this.confirmingSelection = false;
          this.step3 = true;
          this.step2 = false;
          this.selectedSlot = null;
        } catch (err) {
          window.alert(err.body.non_field_errors);
          this.confirmingSelection = false;
          this.findSlots();
        }
      },
      async cancelAppointment() {
              let ok = window.confirm("Are you sure you want to cancel this appointment? This action cannot be undone.");
        if (ok) {
          this.appointmentIdCopied = false;
          this.loadingSlots = true;
          let response = await API.providerCampaigns.unblockAppointment(this.bookedAppointment.id);
          await this.findSlots();
          this.step3 = false;
        }
      },
      handleErrorResponse(errorObj, errorResponse) {
        for (const [key, errorMsgs] of Object.entries(errorResponse.body)) {
          errorObj[key] = errorMsgs.join(' ');
        }
      },
      selectSlot(slot, slotsPerType) {
        if (this.selectedSlot) {
          this.selectedSlot.selected = false;
          this.selectedSlot = null;
        }
        this.selectedSlot = slot;
        this.selectedSlot.selected = true;
        this.selectedSlot.appointment_type = slotsPerType.appointment_type;
          this.selectedSlot.slots = slotsPerType.slots;
          this.selectedSlot.location = slotsPerType.location;
        this.timezone = this.selectedSlot.timezone;
      },
      copyAppointmentId() {
        let self = this;
        navigator.clipboard.writeText(this.bookedAppointment.id).then(function () {
          self.appointmentIdCopied = true;
          self.copyFeedback = true;
          setTimeout(function () {
            self.copyFeedback = false;
          }, 2000);
        });
      },
      restart() {
        this.appointmentIdCopied = false;
        this.step2 = false;
        this.step3 = false;
        this.selectedSlot = null;
        this.availableSlots = [];
        this.zipcode = null,
        this.desired_date = null,
        this.desired_time = null,
        this.bookedAppointment = null;
        Object.keys(this.findSlotsErrors).forEach((key) => {
          this.findSlotsErrors[key] = null;
        });
      }
    }
  }
</script>

<style lang="scss">
  .appointments {
    .buttons-wrapper {
      min-height: 5rem;
    }

    .waiting-spinner {
      height: 1rem;
      margin-bottom: -1rem;
    }

    .slots-ui {
      padding: .5rem;

      + .slots-ui {
        padding-left: 1rem;
      }
    }

    .appointment-slot {
      border: 1px solid #cecece;
      border-radius: 4px 4px 4px 4px;
      padding: .5rem;
      background: #fff;

      &.selected {
        background: #fff8f8;
        box-shadow: 0px 0px 10px #bbb;
        border-color: #ff7a7c;
        border-width: 2px;
        margin: -1px;

        .btn[disabled] {
          border: 2px solid #ff7a7c;
          margin: -1px;
        }
      }

      .appointment-options {
        display: flex;
        gap: .25rem;
        flex-wrap: wrap;
      }
    }

    .copied-feedback {
      display: inline-block;
      color: #ff6666;
      font-weight: 700;
      font-size: 75%;
      position: absolute;
      margin-left: .25rem;
    }

    .copied-feedback::after {
      content: "copied!";
    }
  }

</style>



// WEBPACK FOOTER //
// CampaignForm.vue?b8e779aa